'use strict';exports.__esModule = true;var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _reduce = require('lodash/reduce');var _reduce2 = _interopRequireDefault(_reduce);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var filterData = function filterData(initialData, data) {
  var filteredData = {};
  if (!(0, _isEqual2.default)(initialData, data)) {
    /* eslint-disable no-return-assign */
    (0, _reduce2.default)(data, function (result, value, key) {return (
        (0, _isEqual2.default)(value, initialData[key]) ?
        filteredData :
        filteredData[key] = data[key]);},
    []);
    /* eslint-disable no-return-assign */
  }
  return filteredData;
};exports.default =


filterData;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/filterData.js
// module id = 3134
// module chunks = 0